import { PropsWithChildren, ReactElement, createContext } from "react";
import RedirectAuthHandler from "./AuthProvider.RedirectHandler";
import UserManagerProvider from "./UserManagerProvider";

export type AuthState = "notAuthenticated" | "inProgress" | "authenticated" | "failed";
export const preferredLoginTenantKey = "auim-preferredLoginTenant";

export const loggedOutPath = "/";

// eslint-disable-next-line react-refresh/only-export-components
export const AuthContext = createContext<{ logout(): void }>({ logout: () => { /* empty */ } });

/**
 * Handles all authentication related functionality. Until the user is authenticated it will **not** render the children but a loading/error screen.
 *
 * **Provider dependencies:**
 * - (Store) Provider
 */
export default function AuthProvider({ children }: PropsWithChildren): ReactElement {
  return (
    <UserManagerProvider>
      <RedirectAuthHandler>
        {children}
      </RedirectAuthHandler>
    </UserManagerProvider>
  );
}
